const isDefined = <T>(t: T | null | undefined): t is T => t !== null && t !== undefined

export default isDefined



// WEBPACK FOOTER //
// ./src/helpers/isDefined.ts